// @ts-nocheck
/* eslint-disable */
export default class SceneTile {
	/**
	 * Vytvoreni dlazdice.
	 *
	 * @param  {Number} zoom Zoom
	 * @param  {Number} tileSize Velikost dlazdice
	 * @param  {Number} x Souradnice X
	 * @param  {Number} y Souradnice Y
	 */
	constructor(zoom, tileSize, x, y) {
		this._zoom = zoom;
		this._tileSize = tileSize;
		this._x = x;
		this._y = y;
	}

	/**
	 * Ziskani zoomu.
	 *
	 * @return {Number}
	 */
	get zoom() {
		return this._zoom;
	}

	/**
	 * Ziskani velikosti dlazdice.
	 *
	 * @return {Number}
	 */
	get tileSize() {
		return this._tileSize;
	}

	/**
	 * Ziskani souradnice X.
	 *
	 * @return {Number}
	 */
	get x() {
		return this._x;
	}

	/**
	 * Ziskani souradnice Y.
	 *
	 * @return {Number}
	 */
	get y() {
		return this._y;
	}

	/**
	 * Klon soucasne dlazdice.
	 *
	 * @return {SceneTile}
	 */
	clone() {
		return new SceneTile(this._zoom, this._tileSize, this._x, this._y);
	}

	/**
	 * Prevod dlazdice na string.
	 *
	 * @return {String}
	 */
	toString() {
		return (this._zoom + "-" + this._x + "-" + this._y);
	}
}
